module.exports = __webpack_public_path__ + "static/go-burguer-jogo-nfl-bg-cdf34427f05674743d387ccf45389212.jpg";